import dayjs from 'dayjs';
import { HeroStatus } from 'src/utils/types';
import { ButtonStatus, RentalButtonStatus, ButtonGroupStatus, GuestButtonStatus, InventoryButtonStatus } from './types';
const SECONDS_PER_HOUR = 3600;
const HOURS_PER_DAY = 24;
export const getButtonStatus = ({
  heroDetail,
  currentUser
}) => {
  const {
    hero
  } = heroDetail;

  if (hero.status == HeroStatus.DEFAULT) {
    return ButtonStatus.FREE_HERO;
  }

  const isItemOwnedByUser = currentUser && heroDetail.hero.userAddress.toLocaleUpperCase() === currentUser.address.toLocaleUpperCase();

  if (hero.status === HeroStatus.AVAILABLE && isItemOwnedByUser) {
    return ButtonStatus.IS_SELLABLE;
  }

  if (hero.status === HeroStatus.ON_MARKET && isItemOwnedByUser) {
    return ButtonStatus.IS_STOP_SELLABLE;
  }

  if (hero.status === HeroStatus.ON_MARKET && !isItemOwnedByUser) {
    return ButtonStatus.IS_AVAILABLE;
  }

  return undefined;
};
export const getButtonGroupStatus = ({
  heroDetail,
  currentUser
}) => {
  const {
    hero
  } = heroDetail;
  const isItemOwnedByUser = currentUser && heroDetail.hero.userAddress.toLocaleUpperCase() === currentUser.address.toLocaleUpperCase();

  if (isItemOwnedByUser) {
    return ButtonGroupStatus.INVENTORY;
  }

  if (hero.status === HeroStatus.ON_MARKET) {
    return ButtonGroupStatus.SALE;
  }

  if (hero.status === HeroStatus.FOR_RENT) {
    return ButtonGroupStatus.RENTAL;
  }

  return ButtonGroupStatus.GUEST;
};
export const getRentalButtonStatus = heroDetail => {
  if (heroDetail.hero.status === HeroStatus.FOR_RENT) {
    return RentalButtonStatus.IS_RENTABLE;
  }

  if (heroDetail.hero.status === HeroStatus.RENTED) {
    return RentalButtonStatus.IS_RENTED;
  }

  return undefined;
};
export const getInventoryButtonStatus = heroDetail => {
  const {
    hero: {
      status
    }
  } = heroDetail;

  if (status === HeroStatus.AVAILABLE) {
    return InventoryButtonStatus.IS_AVAILABLE;
  }

  if (status === HeroStatus.FOR_RENT) {
    return InventoryButtonStatus.IS_RENTING;
  }

  if (status === HeroStatus.ON_MARKET) {
    return InventoryButtonStatus.IS_SELLING;
  }

  if (status === HeroStatus.RENTED) {
    return InventoryButtonStatus.IS_RENTED;
  }

  if (status === HeroStatus.HS_RENTED_RELEASED) {
    return InventoryButtonStatus.IS_LOCKED;
  }

  if (status === HeroStatus.USER_NOT_MINT) {
    return InventoryButtonStatus.IS_NOT_MINT;
  }

  if (status === HeroStatus.MINTING || status === HeroStatus.PREPARE_LENDING || status === HeroStatus.PREPARE_SELLING || status === HeroStatus.PREPARE_UNLOCKING || status === HeroStatus.USER_MINTING) {
    return InventoryButtonStatus.IS_PROCESSING;
  }

  return undefined;
};
export const getGuestButtonStatus = heroDetail => {
  if (heroDetail.hero.status === HeroStatus.RENTED) {
    return GuestButtonStatus.IS_RENTED;
  }

  return GuestButtonStatus.IS_NOT_AVAILABLE;
};
export const formatRentedOutPeriod = expiredTime => {
  const nowInSeconds = Date.now() / 1000;
  const remainTime = expiredTime - nowInSeconds;
  const duration = dayjs.duration(remainTime, 'seconds');
  const totalDays = duration.asDays();
  const totalHours = duration.asHours();
  return remainTime > SECONDS_PER_HOUR ? `${Math.floor(totalDays)}D ${Math.ceil(totalHours % HOURS_PER_DAY)}H` : '< 1H';
};